var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return (_vm.clientData && _vm.plan) || (_vm.distributorData && _vm.plan)
    ? _c("div", [_c("router-view", { key: _vm.$router.fullPath })], 1)
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }